<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <transition name="layout-sidebar">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
        v-if="this.$store.state.auth.loggedIn"
      >
        <div class="layout-logo">
          <router-link to="/">
            <img
              src="../assets/logo_company.png"
              alt="Logo"
              style="max-width: 200px;"
            />
          </router-link>
        </div>
        <AppProfile />
        <div v-if="can('seePats')" class="quicksearch-content"
          v-tooltip.left="'Pesquisa rápida (CTRL+K)'"
          @click.prevent="showQuickSearch">
          <a href="#" class="quicksearch-anchor">
            <i class="pi pi-search p-ml-3 p-mr-3"></i>
            <span>Pesquisa rápida</span>
          </a>
        </div>
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>
    <div
      v-bind:class="[
        { 'no-margin-left': !this.$store.state.auth.loggedIn },
        'layout-main',
      ]"
    >
      <AppTabBar v-if="currentUser" />

      <RouteKeepAlive :max="20" :include-keys="tabPaths">
        <router-view :key="$route.path" />
      </RouteKeepAlive>

      <AppQuickSearchPat
        @close="() => showQuickSearchModel = false"
        :show="showQuickSearchModel"
        v-if="can('seePats')" />

      <SidebarStatusControlPatIndicator v-if="can('seeTechnicalManagementStatusControlPatIndicator')" />
      <SidebarServiceOrdersIndicator v-if="can('seeServiceOrders')" />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppTopBar from "@/layouts/AppTopbar.vue";
import AppProfile from "@/layouts/AppProfile.vue";
import AppMenu from "@/layouts/AppMenu.vue";
import AppFooter from "@/layouts/AppFooter.vue";
import AppQuickSearchPat from '@/components/elements/AppQuickSearchPat.vue'
import SidebarStatusControlPatIndicator from '@/components/support/SidebarStatusControlPatIndicator.vue';
import SidebarServiceOrdersIndicator from '@/components/serviceOrders/SidebarServiceOrdersIndicator.vue';
import AppTabBar from '@/components/layout/AppTabBar.vue';
import RouteKeepAlive from '@/components/layout/RouteKeepAlive.js';

export default {
  name: "MainLayout",
  components: {
    AppTopBar,
    AppProfile,
    AppMenu,
    AppFooter,
    AppQuickSearchPat,
    SidebarStatusControlPatIndicator,
    SidebarServiceOrdersIndicator,
    AppTabBar,
    RouteKeepAlive,
  },
  data() {
    return {
      searchValue: "",
      layoutMode: "static",
      layoutColorMode: "dark",
      staticMenuInactive: !this.$store.state.auth.loggedIn,
      overlayMenuActive: false,
      mobileMenuActive: !this.$isMobile(),
      showQuickSearchModel: false,
      menu: [
        {
          label: "Home",
          icon: "pi pi-fw pi-home",
          to: "/",
        },
        {
          label: "Dashboards",
          icon: "pi pi-fw pi-chart-line",
          visible: () => this.can("seeDashboardsMenu") && (this.can("seeOperationsDashboard") || this.can("seeFinanceDashboard")),
          items: [
            {
              label: "Visão 360°",
              icon: "pi pi-fw pi-chart-bar",
              to: "/dashboards",
            }
          ]
        },
        {
          label: "Agenda",
          icon: "pi pi-fw pi-calendar",
          visible: () => this.can("seeSupportSchedule"),
          to: "/support",
        },
        {
          label: "Mapa",
          icon: "pi pi-fw pi-map-marker",
          visible: () => this.can("seeSupportMap"),
          to: "/support/map",
        },
        {
          label: "PATS",
          icon: "pi pi-box",
          visible: () => this.can("seePats"),
          to: "/pats",
        },
        {
          label: "PATs Estados Internos",
          icon: "pi pi-box",
          visible: () => this.can("seeMenuInternalStatesPats"),
          to: "/pats-internal-states",
        },
        {
          label: "Dossiês Internos",
          icon: "pi pi-book",
          visible: () => this.can("seeInternalDossiers"),
          to: "/internal-dossiers",
        },
        {
          label: "Encomendas",
          icon: "pi pi-fw pi-shopping-cart",
          visible: () => this.can("seeOrdersParts"),
          to: "/orders",
        },
        {
          label: "Compras",
          icon: "pi pi-shopping-cart",
          visible: () => this.can("seePurchases"),
          to: "/purchases",
        },
        {
          label: "Transporte",
          icon: "fa-solid fa-cart-flatbed",
          visible: () => this.can("seeTransportDocuments"),
          items: [
            {
              label: "NACEX - Gestão de Expedições",
              icon: "pi pi-fw pi-list",
              visible: () => this.can("seeShipmentTracking"),
              to: "/shipments/nacex",
            },
            {
              label: "Guias de Transporte - Cargas e Descargas",
              icon: "pi pi-fw pi-list",
              visible: () => this.can("seeTransportDocumentsLocations"),
              to: "/transport-documents/locations",
            },
            {
              label: "Acessórios Recepção",
              icon: "pi pi-fw pi-list",
              visible: () => this.can("seeTransportDocumentsLocations"),
              to: "/transport-documents/accessories",
            },
          ],
        },
        {
          label: "Suporte",
          icon: "pi pi-fw pi-sitemap",
          visible: () => this.can("seeSupportCommercial"),
          items: [
            {
              label: "Helpdesk",
              icon: "pi pi-fw pi-wrench",
              visible: () => this.can("seeHelpdeskMenu"),
              items: [
                {
                  label: "Tickets",
                  icon: "pi pi-fw pi-ticket",
                  visible: () => this.can("createHelpdeskTicket"),
                  to: "/helpdesk-tickets",
                },
                {
                  label: "Emails Ignorados",
                  icon: "pi pi-fw pi-envelope",
                  visible: () => this.can("seeBlockedEmails"),
                  to: "/helpdesk-blocked-emails",
                },
                {
                  label: "Assuntos Ignorados",
                  icon: "pi pi-fw pi-list",
                  visible: () => this.can("seeBlockedSubjects"),
                  to: "/helpdesk-blocked-subjects",
                },
                {
                  label: "Categorias",
                  icon: "pi pi-fw pi-list",
                  visible: () => this.can("seeTicketCategories"),
                  to: "/ticket-categories",
                },
              ],
            },
            {
              label: "Gestão Técnica",
              icon: "pi pi-fw pi-sitemap",
              visible: () => this.can("seeTechnicalManagement"),
              items: [
                {
                  label: "Peças a Utilizar",
                  icon: "pi pi-fw pi-ticket",
                  visible: () => this.can("seeTechnicalManagementPartsToUse"),
                  to: "/parts-to-use",
                },
                {
                  label: "Controlo de estados PATs",
                  icon: "pi pi-fw pi-ticket",
                  visible: () => this.can("seeTechnicalManagementStatusControlPat"),
                  to: "/status-control-pats",
                },
                {
                  label: "Controlo de documentação solicitada PATs",
                  icon: "pi pi-fw pi-ticket",
                  visible: () => this.can("seeTechnicalManagementRequestedDocumentationControlPat"),
                  to: "/requested-documentation-control-pats",
                },
                {
                  label: "Propostas Enviadas",
                  icon: "pi pi-fw pi-envelope",
                  visible: () => this.can("seeTechnicalManagementCommercialOfferDispatches"),
                  to: "/commercial-offer-dispatches",
                },
              ],
            },
          ],
        },
        {
          label: "Stock",
          icon: "pi pi-truck",
          visible: () => this.can("seeStock"),
          to: "/stocks",
        },
        {
          label: "Ordens de Serviço",
          icon: "pi pi-fw pi-list",
          visible: () => this.can("seeServiceOrders"),
          items: [
            {
              label: "LG",
              icon: "",
              visible: () => this.can("seeServiceOrdersLG"),
              to: "/serviceOrders/lg",
            },
            {
              label: "Hisense",
              icon: "",
              visible: () => this.can("seeServiceOrdersHisense"),
              to: "/serviceOrders/hisense",
            },
            {
              label: "Domestic & General",
              icon: "",
              visible: () => this.can("seeServiceOrdersDg"),
              to: "/serviceOrders/dg",
            },
            {
              label: "Clientes",
              icon: "",
              visible: () => this.can("seeExtranetServiceOrders"),
              to: "/serviceOrders/extranet",
            },
          ],
        },
        {
          label: "Loja Online",
          icon: "pi pi-fw pi-server",
          visible: () => this.can("seeSpars"),
          items: [
            {
              label: "Lista de Equipamentos",
              icon: "",
              to: "/spars/equipments",
            },
            {
              label: "Produtos",
              icon: "",
              items: [
                {
                  label: "Lista de Produtos",
                  icon: "",
                  to: "/spars/products",
                },
                {
                  label: "Família",
                  icon: "",
                  to: "/spars/product/families",
                }
              ],
            },
            {
              label: "Categorias",
              icon: "",
              to: "/spars/categories",
            },
            {
              label: "Marcas",
              icon: "",
              to: "/spars/brands",
            },
            {
              label: "Fornecedores",
              icon: "",
              to: "/spars/suppliers",
            },
            {
              label: "Imagens",
              icon: "",
              to: "/spars/images",
            },
            {
              label: "Administração",
              icon: "",
              to: "/spars/administration",
            }
          ],
        },
        {
          label: "Frota",
          icon: "pi pi-fw pi-car",
          visible: () => this.can("seeFleet") || this.can("seeTargaTelematics"),
          items: [
            {
              label: "Veículos",
              icon: "pi pi-fw pi-car",
              visible: () => this.can("seeFleetVehicles"),
              to: "/vehicles",
            },
            {
              label: "Telemetria",
              icon: "pi pi-fw pi-map-marker",
              visible: () => this.can("seeTargaTelematics"),
              to: "/telemetry",
            },
          ],
        },
        {
          label: "Entidades",
          icon: "pi pi-fw pi-briefcase",
          visible: () =>
            this.can("seeClients") ||
            this.can("seeEquipments") ||
            this.can("seeEntities") ||
            this.can("seeSuppliers"),
          items: [
            {
              label: "Clientes",
              icon: "pi pi-users",
              visible: () => this.can("seeClients"),
              to: "/clients",
            },
            {
              label: "Fornecedores",
              icon: "pi pi-truck",
              visible: () => this.can("seeSuppliers"),
              to: "/suppliers",
            },
            {
              label: "Entidades",
              icon: "pi pi-building",
              visible: () => this.can("seeEntities"),
              to: "/entities",
            },
            {
              label: "Equipamentos",
              icon: "pi pi-cog",
              visible: () => this.can("seeEquipments"),
              to: "/equipments",
            },
          ],
        },
        {
          label: "Recursos Humanos",
          icon: "pi pi-fw pi-users",
          items: [
            {
              label: "Férias",
              icon: "fa-solid fa-umbrella-beach",
              items: [
                {
                  label: "As minhas Férias",
                  icon: "fa-solid fa-umbrella-beach",
                  to: "/vacations",
                },
                {
                  label: "Férias da Equipa",
                  icon: "pi pi-fw pi-users",
                  to: "/vacationsTeam"
                },
                {
                  label: "Aprovar",
                  icon: "pi pi-fw pi-check",
                  visible: () => this.can("approveVacations"),
                  to: "/vacationsApprove"
                },
              ],
            },
            {
              label: "Despesas",
              icon: "pi pi-fw pi-euro",
              visible: () =>
                this.currentUser.isEsa || this.can("seeExpenditureMenu"),
              items: [
                {
                  label: "Ver",
                  icon: "pi pi-fw pi-eye",
                  to: "/expenditure",
                  visible: () =>
                    this.currentUser.isEsa || this.can("seeExpenditures"),
                },
                {
                  label: "Aprovar",
                  icon: "pi pi-fw pi-check",
                  to: "/expenditure-approve",
                  visible: () =>
                    this.currentUser.isEsa || this.can("seeExpenditureApprove"),
                },
              ],
            },
            {
              label: "Faltas",
              icon: "pi pi-fw pi-user-minus",
              visible: () => this.currentUser.isEsa || this.can("seeMissMenu"),
              items: [
                {
                  label: "Ver",
                  icon: "pi pi-fw pi-eye",
                  to: "/miss",
                  visible: () => this.currentUser.isEsa || this.can("seeMiss"),
                },
                {
                  label: "Aprovar",
                  icon: "pi pi-fw pi-check",
                  to: "/miss-approve",
                  visible: () =>
                    this.currentUser.isEsa || this.can("seeMissApprove"),
                },
              ],
            },
            {
              label: "Fichas de Colaboradores",
              icon: "pi pi-users",
              visible: () => this.can("seeEmployeeFiles"),
              to: "/employeeFiles",
            },
          ],
        },
        {
          label: "Administração",
          icon: "pi pi-fw pi-sliders-v",
          visible: () => this.can("seeAdministrationMenu"),
          items: [
            {
              label: "ACLs",
              icon: "pi pi-lock-open",
              visible: () => this.can("seeAclsMenu"),
              items: [
                {
                  label: "Ver Acls",
                  icon: "pi pi-fw pi-eye",
                  visible: () => this.can("seeAcls"),
                  to: "/acls",
                },
                {
                  label: "Categorias",
                  icon: "pi pi-fw pi-tag",
                  visible: () => this.can("seeAclsCategories"),
                  to: "/acls-categories",
                },
                {
                  label: "Grupos",
                  icon: "pi pi-fw pi-th-large",
                  visible: () => this.can("seeAclsGroups"),
                  to: "/acls-groups",
                },
                {
                  label: "Utilizadores",
                  icon: "pi pi-fw pi-users",
                  visible: () => this.can("viewUserGroupAndAcls"),
                  to: "/acls-users",
                },
              ],
            },
            {
              label: "PATs Organizer",
              icon: "pi pi-align-justify",
              visible: () => this.can("seePats"),
              to: "/pats/status",
            },
            {
              label: "PATs Estados Internos",
              icon: "pi pi-align-justify",
              visible: () => this.can("seeAdminInternalStatesPats"),
              to: "/pats/internal-states",
            },
            {
              label: "Conta Google",
              icon: "pi pi-google",
              visible: () => this.can("importContactsToGoogleAccount"),
              to: "/googleContacts",
            },
            {
              label: "Contas NACEX",
              icon: "pi pi-truck",
              visible: () => this.can("seeNacexAccounts"),
              to: "/nacex-accounts",
            },
            {
              label: "Extranet",
              icon: "pi pi-fw pi-sliders-v",
              visible: () => this.can("seeExtranetMenu"),
              items: [
                {
                  label: "Users",
                  icon: "pi pi-users",
                  visible: () => this.can("seeExtranetUser"),
                  to: "/extranet-users",
                },
                {
                  label: "Estados",
                  icon: "pi pi-tag",
                  visible: () => this.can("seeExtranetStatus"),
                  to: "/extranet-status",
                },
              ],
            },
            {
              label: "Notificações",
              icon: "pi pi-bell",
              visible: () => this.can("seeNotificationsSettings"),
              items: [
                {
                  label: "Histórico de Notificações",
                  icon: "pi pi-send",
                  visible: () => this.can("seeNotificationsSettings"),
                  to: "/notifications-logs",
                },
                {
                  label: "SMS - Confirmação de intervenção",
                  icon: "pi pi-send",
                  visible: () => this.can("seeNotificationsSettings"),
                  to: "/notifications-settings-sms",
                },
                {
                  label: "SMS - Solicitação de documentos",
                  icon: "pi pi-send",
                  visible: () => this.can("seeNotificationsSettings"),
                  to: "/notifications-settings-sms-request-docs",
                },
                {
                  label: "Email - Solicitação de documentos",
                  icon: "pi pi-send",
                  visible: () => this.can("seeNotificationsSettings"),
                  to: "/notifications-settings-email-request-docs",
                },
              ]
            },
            {
              label: "Integração LG",
              icon: "pi pi-fw pi-list",
              visible: () => this.can("seeIntegrationLgSettings"),
              items: [
                {
                  label: "Códigos de Configuração",
                  icon: "pi pi-fw pi-cog",
                  visible: () => this.can("seeIntegrationLgSettings"),
                  to: "/integration-lg/config-codes",
                }
              ]
            },
            {
              label: "Logs",
              icon: "pi pi-fw pi-list",
              visible: () => this.can("seeLogs"),
              to: "/logs",
            },
            {
              label: "Auditorias",
              icon: "pi pi-fw pi-history",
              visible: () => this.can("seeAudits"),
              to: "/audits",
            }
          ],
        },
      ],
    };
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleCtrlK);
  },
  methods: {
    goToSeach() {
      this.$router.push(`/search/${this.searchValue}`);
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }
          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }
      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    onLayoutColorChange(layoutColorMode) {
      this.layoutColorMode = layoutColorMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
    showQuickSearch() {
      this.showQuickSearchModel = true;
    },
    handleCtrlK(event) {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        this.showQuickSearch();
      }
    }
  },
  watch: {
    $route(to) {
      if (to && to.name && this.$store.state.auth.loggedIn) {
        this.$store.dispatch('tabs/openTab', to);
      }
    },
  },

  computed: {
    tabs() {
      return this.$store.getters["tabs/tabs"];
    },
    tabPaths() {
      return this.tabs.map((t) => t.path);
    },
    currentUser() {
      if (this.$store.state.auth.loggedIn) {
        return this.$store.state.auth.user;
      }
      return null;
    },
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$appState.inputStyle === "filled",
          // 'p-ripple-disabled': this.$primevue.ripple === false
        },
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login").catch(() => {});
    }

    if (this.$route && this.$route.name && this.$store.state.auth.loggedIn) {
      this.$store.dispatch('tabs/openTab', this.$route);
    }

    window.addEventListener("keydown", this.handleCtrlK);

    return this.$store.state.auth.user;
  },
  beforeUpdate() {
    if (this.mobileMenuActive) {
      this.addClass(document.body, "body-overflow-hidden");
    } else {
      this.removeClass(document.body, "body-overflow-hidden");
    }
  },
};
</script>
<style>

.quicksearch-content {
    width: 100%;
    margin: 10px auto;
    cursor: pointer;
}

.quicksearch-anchor {
    color: #fff;
}

.no-margin-left {
  margin-left: 0px !important;
}
</style>
